import type { App } from "@upsquad/server";
import type { EdenCall } from "@/src/common/lib/eden-base-query";
import { baseApi } from "@/src/common/services/base-api";

type GetCalendarConnectionsResponse = App["~Routes"]["calendar"]["connections"]["get"]["response"]["200"];
type UnlinkCalendarResponse = App["~Routes"]["calendar"]["connections"][":connectionId"]["delete"]["response"]["200"];

const memberCalendarApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getCalendarConnections: builder.query<GetCalendarConnectionsResponse, void>({
			query: (): EdenCall<GetCalendarConnectionsResponse> => (client) => client.calendar.connections.get(),
			providesTags: ["Calendar"],
		}),
		unlinkCalendar: builder.mutation<UnlinkCalendarResponse, string>({
			query: (connectionId) => (client) => client.calendar.connections({ connectionId }).delete(),
			invalidatesTags: ["Calendar"],
		}),
	}),
});

export const { useGetCalendarConnectionsQuery, useUnlinkCalendarMutation } = memberCalendarApi;
